import {CheckoutGuestsInformationForm} from "./checkoutGuestsInformationForm";
import {CheckoutLeaderInformationForm} from "./checkoutLeaderInformationForm";
import {isGustsInformationRequired} from "./checkoutUtils";

export class CheckoutGuestsInformationFormProvider {

    constructor() {
        return this;
    }

    /**
     * Get checkout guests information form render
     * @return {CheckoutLeaderInformationForm|CheckoutGuestsInformationForm}
     */
    getCheckoutGuestsInformationForm()
    {
        if(isGustsInformationRequired()) {
            return new CheckoutGuestsInformationForm();
        } else {
            return new CheckoutLeaderInformationForm();
        }
    }
}